export default __webpack_public_path__ + "static/media/dark_file_plus.07719399.svg";